var app = angular.module('leonardo');

var DeficiencyTagService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('deficiency-tags', function(RestangularConfigurer) {
    // This is intentional do_something blank function
  });

  service.getTagsList = function(params) {
    return RestangularProvider.all('dynamic-forms').customGET('tags', params);
  };

  service.getIncludeTagsList = function(iparams) {
    var params = {page: iparams.page, limit: iparams.limit, dynamic_form_id: iparams.dynamic_form_id, search: iparams.search};
    if(iparams.id) {
      params.tagids = JSON.stringify((iparams.id).split(','));
    }
    return RestangularProvider.all('dynamic-forms').customGET('tags/include_tags', params);
  };

  service.createTag = function(tagData) {
    return RestangularProvider.all('dynamic-forms').customPOST(tagData, 'tags');
  };

  service.updateTag = function(tagData, tagId) {
    return RestangularProvider.all('dynamic-forms').customPUT(tagData, 'tags/'+tagId );
  };

  return service;
};

app.factory('DeficiencyTagService', ['BaseRestService', 'Restangular', DeficiencyTagService]);
